module.exports = __webpack_public_path__ + "img/stripe-logo.e4590c1a.svg";